
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('HOME_LAST_STATUS').plugin(axiosPlugin, {template: "array"});

let fetchLastStatusAction = redux.fetchActionGet();

export const fetchLastStatus = () => fetchLastStatusAction(`/features/status`);

export const homeLastStatus = redux.reducer();